import { useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from 'src/pages/quiz/contextAPI'
import { PATH_URL } from 'src/helpers'
import { pushQuizStep } from 'src/helpers/quizEntry'
import { ENV } from 'src/config/env'

export const useEssentialsCollection = () => {
  const history = useHistory()
  const { search } = useLocation()
  const { setQuizScreen } = useContext(QuizQuestionContext)

  const handleNext = async () => {
    const currentTempPoppyData = JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}')
    localStorage.setItem(
      'tempPoppySessionData',
      JSON.stringify({
        ...currentTempPoppyData,
      })
    )
    pushQuizStep(history, PATH_URL.CONTACT_INFO, search)
    setQuizScreen(SCREEN_QUIZ_QUESTION.CONTACT_INFO)
  }

  const handleBack = () => {
    if (window.history.length > 1) {
      history.goBack()
    } else {
      pushQuizStep(history, PATH_URL.NEW_BUDGET_PAGE, search)
      setQuizScreen(SCREEN_QUIZ_QUESTION.NEW_BUDGET_PAGE)
    }
  }

  const handleGoToEssentialsCollection = () => {
    window.open(ENV.ESSENTIALS_COLLECTION_URL, '_blank')
  }

  return {
    handleBack,
    handleNext,
    handleGoToEssentialsCollection,
  }
}
